{
  "YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT": "Phản hồi và đề xuất của bạn sẽ giúp chúng tôi cải thiện sản phẩm và dịch vụ của mình.",
  "TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP": "Nếu bạn gặp vấn đề về kỹ thuật hoặc hỗ trợ hoặc cần hỗ trợ ngay lập tức, vui lòng liên hệ với Quản trị viên hoặc Nhà cung cấp giải pháp Laserfiche của bạn như được nêu trong thỏa thuận dịch vụ của bạn.",
  "FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW": "Tìm thấy thứ gì đó bạn thích hoặc không thích? Hãy cho chúng tôi biết về nó.",
  "DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING": "Bạn có ý tưởng cho một tính năng mới hoặc một cải tiến không? Chúng tôi mong được nghe về nó.",
  "PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK": "Vui lòng không bao gồm bất kỳ thông tin bí mật hoặc cá nhân nào trong phản hồi của bạn",
  "TELL_US_ABOUT_EXPERIENCE": "Hãy cho chúng tôi biết về trải nghiệm của bạn",
  "TELL_US_ABOUT_IDEA": "Hãy cho chúng tôi biết về ý tưởng của bạn",
  "I_HAVE_FEEDBACK": "Tôi có phản hồi",
  "I_HAVE_SUGGESTION": "Tôi có một đề xuất",
  "YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK": "Bạn có thể liên hệ với tôi về phản hồi này",
  "IF_YOUD_LIKE_TO_JOIN_OUR_CUSTOMER_PANEL": "Nếu bạn muốn tham gia Bảng điều khiển khách hàng của chúng tôi,",
  "PLEASE_CLICK_HERE": "Vui lòng nhấp vào đây.",
  "IMAGE_EXCEEDS_MAX_FILE_SIZE_0": "Hình ảnh vượt quá kích thước tệp tối đa là {0}.",
  "IMAGE_CORRUPTED_UNRECOGNIZED_FORMAT": "Hình ảnh bị hỏng hoặc ở định dạng không được nhận dạng.",
  "ACCEPTED_FORMATS_ARE_0": "Các định dạng được chấp nhận là: {0}.",
  "IMAGE_NOT_ATTACHED": "Hình ảnh không đính kèm.",
  "ATTACH_IMAGE": "Đính kèm hình ảnh",
  "PLEASE_ATTACH_ONLY_ONE_IMAGE": "Vui lòng chỉ đính kèm một hình ảnh.",
  "TAGS": "thẻ",
  "ADD_TAGS": "Thêm thẻ",
  "ADD_MORE_TAGS": "Thêm nhiều thẻ khác",
  "NO_TAGS_AVAILABLE": "Không có thẻ nào có sẵn"
}
